import {BUSCAR_ITINERARIOS, LIMPAR_ITINERARIOS} from '../../actions/types'

const initialState = undefined;

export default function reducerBuscarTrechos (state = {}, action = initialState) {
  switch (action.type) {
    case BUSCAR_ITINERARIOS: {
      const itinerarios = action.payload.data;

      if (itinerarios) {
        return itinerarios
      }
      return []
    }

    case LIMPAR_ITINERARIOS:
      return {};

    default: {
      return state
    }
  }
}
